/** @jsx jsx */

import {
  Avatar,
  BetaMenuTriggerRoot,
  BetaMenuTriggerPopover,
  BetaMenuTriggerList,
  BetaMenuTriggerItem,
} from '@zapier/design-system';
import { css, jsx } from '@emotion/core';
import { Pressable } from 'react-aria-components';

const Styles = {
  avatarButton: css`
    background-color: transparent !important;
    border: none !important;
    cursor: pointer !important;
  `,
};

type Props = {
  isOpen: boolean;
  onClickLogOut?: () => void;
  onClickSettings?: () => void;
  onClickZapier?: () => void;
  onToggle: () => void;
  urlLogOut: string;
  urlSettings: string;
  urlZapier: string;
  user: {
    avatarUrl: string;
    name: string;
  };
};

const UserDropdown = ({
  isOpen,
  onClickLogOut,
  onClickSettings,
  onClickZapier,
  onToggle,
  urlLogOut,
  urlSettings,
  urlZapier,
  user,
}: Props) => {
  return (
    <nav>
      <BetaMenuTriggerRoot
        isOpen={isOpen}
        onOpenChange={open => {
          if (open !== isOpen) onToggle();
        }}
      >
        <Pressable>
          <button css={Styles.avatarButton}>
            <Avatar
              isSelected={isOpen}
              name={user.name}
              size="medium"
              url={user.avatarUrl}
            />
          </button>
        </Pressable>
        <BetaMenuTriggerPopover
          placement="bottom end"
          style={{ minWidth: '198px' }}
        >
          <BetaMenuTriggerList
            aria-label="User options"
            onAction={key => {
              switch (key) {
                case 'settings':
                  onClickSettings?.();
                  window.location.href = urlSettings;
                  break;
                case 'zapier':
                  onClickZapier?.();
                  window.location.href = urlZapier;
                  break;
                case 'logout':
                  onClickLogOut?.();
                  window.location.href = urlLogOut;
                  break;
              }
            }}
          >
            <BetaMenuTriggerItem id="settings">Settings</BetaMenuTriggerItem>
            <BetaMenuTriggerItem id="zapier">Zapier.com</BetaMenuTriggerItem>
            <BetaMenuTriggerItem id="logout">Log out</BetaMenuTriggerItem>
          </BetaMenuTriggerList>
        </BetaMenuTriggerPopover>
      </BetaMenuTriggerRoot>
    </nav>
  );
};

export default UserDropdown;
